export default __webpack_public_path__ + "static/impulsamos-a6b844a9f42e61782b3b9e82bd3562a4.png";